import * as React from 'react';
import { useState, useEffect } from "react";
import useHash from "../../js/helpers/useHash.ts";
import DialogStyled from "../components/dialogStyled.tsx";
import CallbackForm from "../form/callbackForm.tsx";

type Props = Readonly<{}>

function CallbackListener({...otherProps}: Props) {
	const [showModal, setShowModal] = useState<boolean>(false);
	const [hash, setHash] = useHash();

	useEffect(() => {
		if (hash === '#callback') {
			setShowModal(true);
		}
	}, [hash]);

	return (<>
		<DialogStyled
			isOpen={showModal}
			onClose={() => { setShowModal(false); setHash(''); }}
			classesSize={"max-w-screen-md max-h-[97vh]"}
			zIndex={50}
		>
			<div className="w-full h-full bg-blackAlmost py-8 lg:py-12 px-8 lg:px-16 overflow-hidden max-w-screen-lg">
				<div className="text-center">
					<h3 className="mt-0">Request a callback</h3>
				</div>
				<CallbackForm/>
			</div>
		</DialogStyled>
	</>);
}

export default CallbackListener;
